import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = 'app';
  // ng build -prod --aot=false
  ngOnInit(): void {
    // console.log("Imdsdsplement the ngOnInit");
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts